import { useNavigate } from "react-router-dom";

import { useV2ProductTypes } from "@jasper/product-workflows";
import { ItemType, NEW_PAP_WORKFLOW_ACTIVATION_DATE } from "@jasper/shared";
import { useCombinedWorkflowOrderStore } from "/@/shared/stores/orders/create-combined-workflow-store.store";
import { useCreateOrderStore } from "/@/shared/stores/orders/create-store.store";
import { CreateOrderStep } from "/@/shared/types/orders/createOrder.types";

export type DraftOrderToResume = {
  id: string;
  createdAt: unknown;
  productTypes: string[];
};

export const useResumeDraftOrder = () => {
  const navigate = useNavigate();
  const { isV2Product } = useV2ProductTypes();

  const { updateNewCombinedOrderId, updateCombinedWorkflowProducts } =
    useCombinedWorkflowOrderStore();

  const {
    updateCreateOrderStep,
    updateCreateProductStep,
    updateCreateProductIndex,
    updateProductNewWFStep,
  } = useCreateOrderStore();

  return ({ id, createdAt, productTypes }: DraftOrderToResume) => {
    if (productTypes.length === 0) {
      navigate(`/orders/${id}/configure/products/add`);
      return;
    }

    if (productTypes.every(type => isV2Product(type))) {
      navigate(`/orders/${id}/configure/products/resume`);
      return;
    }

    const itemTypes = productTypes.filter(Boolean) as ItemType[];

    updateCombinedWorkflowProducts(itemTypes);
    updateNewCombinedOrderId(id);
    updateCreateProductIndex(0);
    updateCreateProductStep(0);
    updateProductNewWFStep(0);

    const shouldUseNewWorkflow =
      itemTypes.includes(ItemType.PARTIAL_DENTURE) &&
      new Date(createdAt as number).getTime() >
        NEW_PAP_WORKFLOW_ACTIVATION_DATE.getTime();

    if (shouldUseNewWorkflow) {
      updateCreateOrderStep(CreateOrderStep.Product);
      navigate("/create-new-order", {
        state: {
          id,
          workflow: productTypes,
          cameFromOtherProduct: false,
        },
      });
    } else {
      updateCreateOrderStep(CreateOrderStep.Patient);
      navigate("/create-order", { state: { id } });
    }
  };
};
